/* edelstahlonline24 — Theme JS
   Minimal, no framework. Newsletter, cart count, PDP interactions.
*/
(function () {
  // Newsletter inline-feedback
  document.querySelectorAll('form[data-newsletter]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = f.querySelector('button');
      var orig = btn.textContent;
      btn.textContent = 'Danke!';
      btn.disabled = true;
      setTimeout(function () { btn.textContent = orig; btn.disabled = false; f.reset(); }, 2500);
    });
  });

  // PDP — gallery thumbs
  var pdpGallery = document.querySelector('[data-pdp-gallery]');
  if (pdpGallery) {
    var thumbs = pdpGallery.querySelectorAll('[data-thumb-id]');
    var medias = pdpGallery.querySelectorAll('[data-media-id]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var id = t.dataset.thumbId;
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
        medias.forEach(function (m) { m.classList.toggle('is-active', m.dataset.mediaId === id); });
      });
    });
  }

  // PDP — qty +/-
  document.querySelectorAll('.pdp__qty').forEach(function (qty) {
    var input = qty.querySelector('.js-qty-input');
    var minus = qty.querySelector('.js-qty-minus');
    var plus = qty.querySelector('.js-qty-plus');
    if (minus && input) minus.addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    if (plus && input) plus.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });

  // PDP — tabs
  var tabBtns = document.querySelectorAll('.pdp-tabs__btn');
  var tabPanels = document.querySelectorAll('.pdp-tabs__panel');
  tabBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      var id = b.dataset.tab;
      tabBtns.forEach(function (x) { x.classList.toggle('is-active', x === b); });
      tabPanels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.panel === id); });
    });
  });

  // Header — dropdown menus (hover on desktop, click on touch/mobile)
  var navGroups = document.querySelectorAll('[data-nav-group]');
  var isTouch = window.matchMedia('(max-width: 760px)').matches || ('ontouchstart' in window);
  navGroups.forEach(function (group) {
    var toggle = group.querySelector('[data-nav-toggle]');
    if (!toggle) return;

    // Hover (desktop)
    group.addEventListener('mouseenter', function () {
      if (!window.matchMedia('(max-width: 760px)').matches) {
        navGroups.forEach(function (g) { g.classList.remove('is-open'); });
        group.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
    group.addEventListener('mouseleave', function () {
      if (!window.matchMedia('(max-width: 760px)').matches) {
        group.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });

    // Click (mobile / touch) — toggle, and on desktop first tap opens instead of navigating
    toggle.addEventListener('click', function (e) {
      if (window.matchMedia('(max-width: 760px)').matches) {
        e.preventDefault();
        var open = group.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    });
  });

  // Close any open dropdown when clicking outside
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-nav-group]')) {
      navGroups.forEach(function (g) {
        g.classList.remove('is-open');
        var t = g.querySelector('[data-nav-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
  });

  // Header — mobile burger off-canvas
  (function () {
    var header = document.querySelector('.site-header');
    var burger = document.querySelector('[data-nav-burger]');
    var closeBtn = document.querySelector('[data-nav-close]');
    var overlay = document.querySelector('[data-nav-overlay]');
    if (!header || !burger) return;
    function open() { header.classList.add('nav-open'); document.body.classList.add('nav-locked'); burger.setAttribute('aria-expanded', 'true'); }
    function close() { header.classList.remove('nav-open'); document.body.classList.remove('nav-locked'); burger.setAttribute('aria-expanded', 'false'); }
    burger.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    // Close when navigating to a real link (not a parent toggle) on mobile
    document.querySelectorAll('.site-nav__col-title, .site-nav__col-list a, .site-nav__item:not([data-nav-toggle])').forEach(function (a) {
      a.addEventListener('click', function () { if (window.matchMedia('(max-width: 760px)').matches) close(); });
    });
  })();

  // Predictive (live) search
  (function () {
    var form = document.querySelector('[data-predictive-search]');
    if (!form) return;
    var input = form.querySelector('[data-predictive-input]');
    var box = form.querySelector('[data-predictive-results]');
    if (!input || !box) return;
    var timer, lastQuery = '';
    var SEARCH_OPTS = '&options[prefix]=last&options[fields]=title,product_type,variants.title,variants.sku,vendor,tag';

    function hide() { box.hidden = true; box.innerHTML = ''; }

    function render(data, q) {
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];
      var queries = (data.resources && data.resources.results && data.resources.results.queries) || [];
      if (!products.length && !queries.length) {
        box.innerHTML = '<div class="predictive__empty">Keine Treffer fuer &bdquo;' + q + '&ldquo;</div>';
        box.hidden = false;
        return;
      }
      var html = '';
      if (products.length) {
        html += '<div class="predictive__label">Produkte</div>';
        products.slice(0, 6).forEach(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
          html += '<a class="predictive__item" href="' + p.url + '">' +
            (img ? '<span class="predictive__thumb"><img src="' + img + '" alt="" loading="lazy"></span>' : '<span class="predictive__thumb"></span>') +
            '<span class="predictive__info"><span class="predictive__title">' + p.title + '</span>' +
            (p.price ? '<span class="predictive__price">' + p.price + '</span>' : '') +
            '</span></a>';
        });
      }
      if (queries.length) {
        html += '<div class="predictive__label">Vorschlaege</div>';
        queries.slice(0, 4).forEach(function (qq) {
          html += '<a class="predictive__query" href="/search?q=' + encodeURIComponent(qq.text) + SEARCH_OPTS + '">' + (qq.styled_text || qq.text) + '</a>';
        });
      }
      html += '<a class="predictive__all" href="/search?q=' + encodeURIComponent(q) + SEARCH_OPTS + '">Alle Ergebnisse fuer &bdquo;' + q + '&ldquo; anzeigen &rarr;</a>';
      box.innerHTML = html;
      box.hidden = false;
    }

    function run(q) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,query&resources[limit]=6&section_id=predictive-search';
      // suggest.json ignores section_id; plain endpoint:
      url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,query&resources[limit]=6' +
       '&resources[options][unavailable_products]=last' +
       '&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) { if (input.value.trim() === q) render(data, q); })
        .catch(hide);
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { hide(); return; }
      if (q === lastQuery) return;
      lastQuery = q;
      timer = setTimeout(function () { run(q); }, 200);
    });
    input.addEventListener('focus', function () { if (box.innerHTML) box.hidden = false; });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) hide(); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
  })();

  // Cart count update (placeholder hook)
  document.addEventListener('cart:updated', function (e) {
    var count = (e.detail && e.detail.item_count) || 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  });
})();
